import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import 'react-quill/dist/quill.snow.css';
import 'react-quill/dist/quill.core.css';
import ReactQuill, { Quill } from 'react-quill';
import quillTable from "quill-table";
import SelectImages from '../../selectImages';
import MyLink from '../../../helpers/quill.helper';
import { createTableOptions } from '../../../helpers/tableOptions.helper';

Quill.register(MyLink);

Quill.register(quillTable.TableCell);
Quill.register(quillTable.TableRow);
Quill.register(quillTable.Table);
Quill.register(quillTable.Contain);
Quill.register("modules/table", quillTable.TableModule);

function imageHandler(props, $quill) {
  const cursorIndex = $quill.quill.getSelection().index;
  props.setQuillCursorPosition(cursorIndex);
  props.setModalOpen(!props.modalOpen);
}

const Editor = (props) => {
  const image = useCallback(
    function () {
      imageHandler(props, this);
    },
    [props.setModalOpen, props.setQuillCursorPosition],
  );


  const modules = {
    table: true,
    toolbar: {
      container: [
        [{ table: createTableOptions() },{ table: "append-row" },{ table: "append-col" }],
        ['bold', 'italic', 'underline', 'strike'], // toggled buttons
        ['blockquote', 'code-block'],
        [{ list: 'ordered' }, { list: 'bullet' }],
        [{ script: 'sub' }, { script: 'super' }], // superscript/subscript
        [{ indent: '-1' }, { indent: '+1' }], // outdent/indent
        [{ direction: 'rtl' }], // text direction
        [{ size: ['small', false, 'large', 'huge'] }], // custom dropdown
        [{ header: [1, 2, 3, 4, 5, 6, false] }],
        [{ color: [] }, { background: [] }], // dropdown with defaults from theme
        [{ font: [] }],
        [{ align: [] }],
        ['image', 'clean', 'link'],
      ],
      handlers: {
        image,
      },
    },
  };
  return (
    <React.Fragment>
      {props.modalOpen && <SelectImages onImageClick={props.pasteImage} />}
      <ReactQuill
        className={[
          props.valid || typeof props.valid === 'undefined' ? '' : 'invalid',
          'Editor',
        ]}
        value={props.content}
        onChange={(value) => {
          props.setContent(value);
        }}
        modules={modules}
      />
    </React.Fragment>
  );
};

Editor.propTypes = {
  setValue: PropTypes.func.isRequired,
  value: PropTypes.string.isRequired,
};

export default Editor;



// WEBPACK FOOTER //
// ./src/components/cms/editor/Editor.jsx